import { Save } from "lucide-react";
import ImageDropField from "./ImageDropField";

export default function HeroEditor({ images, onChange, onFileUpload, onSave, saving }) {
  const updateImage = (index, value) => {
    const next = [...images];
    next[index] = value;
    onChange(next);
  };

  return (
    <div className="catalog-editor" data-testid="admin-hero-panel">
      <p className="admin-panel-hint">Ana sayfa hero ve hikâye alanındaki görselleri sürükleyip bırakın.</p>
      <div className="hero-editor-grid">
        {[0, 1].map((index) => (
          <article key={index}>
            <label>{index === 0 ? "Hero görseli" : "Hikâye görseli"}<input value={images[index] || ""} onChange={(event) => updateImage(index, event.target.value)} data-testid={`hero-image-url-input-${index + 1}`} /></label>
            <ImageDropField image={images[index]} label="Görseli sürükleyin" onFileUpload={(file) => onFileUpload(index, file)} inputTestId={`hero-image-upload-input-${index + 1}`} rootTestId={`hero-image-dropzone-${index + 1}`} />
          </article>
        ))}
      </div>
      <button onClick={onSave} disabled={saving} className="admin-save" data-testid="save-hero-button"><Save size={17} /> Hero görsellerini kaydet</button>
    </div>
  );
}